
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch, AppState } from "../store/configureStore";
import BasePage from "./UI/BasePage";
import { Col } from "react-bootstrap";
import SimpleCard from "./UI/SimpleCard";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createTask, deleteTask, getActiveTasksForWorker } from "../store/slices/candidateProcesses";
import { useEffect } from "react";


const TestPage = () => {
    const { t } = useTranslation("candidate_portal");
    const dispatch = useDispatch<AppDispatch>();
    const workerId = useSelector((state: AppState) => state.users.auth.data?.WorkerId) || 9;

    const { list: tasks, loading: processesLoading, reloadTrigger } = useSelector(
        (state: AppState) => state.entities.candidateTasks
    );

    const onCreateProcess = () => {
        dispatch(createTask(workerId));
    };

    useEffect(() => {
        dispatch(getActiveTasksForWorker(workerId));
    }, [dispatch, reloadTrigger, workerId]);

    useEffect(() => {
        console.log("TestPage","BusinessProcessTasks updated:", tasks);
    }, [tasks]);

    const handleDelete = (processId: number) => {
        if (window.confirm('Are you sure you want to delete this process?')) {
            dispatch(deleteTask(processId));
        }
    };

    if (processesLoading) {
        return <div>Loading...</div>;
    }

    return (
        <BasePage className="page-candidate-dashboard">
            <Row>
                <Col>
                    <SimpleCard
                        title="Job offer test helper"
                        className="card-alert"
                    >
                        <>
                            <Button variant="primary" onClick={onCreateProcess}>
                                Create BusinessProcessTask for Worker ID = {workerId}
                            </Button>
                            <div className="process-list">
                                <h2>Tasks</h2>
                                {tasks.length === 0 ? (
                                    <p>No tasks found</p>
                                ) : (
                                    <ul>
                                        {tasks.map((task, index) => (
                                            <li key={task.Id || `fallback-key-${index}`} className="process-item">
                                                <span className='me-1'>{`Task ID: ${task.Id};`}</span>
                                                <span className='me-1'>{`Name: ${task.Name};`}</span>
                                                <span className='me-1'>{`Task overall status: ${task.Status}`}</span>
                                                <Button variant="primary"
                                                    onClick={() => handleDelete(task.Id)}
                                                    disabled={processesLoading}
                                                   
                                                >
                                                    Delete
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </>
                    </SimpleCard>
                </Col>
            </Row>
        </BasePage>
    )
};
export default TestPage;
